// extracted by mini-css-extract-plugin
export var boldText = "_6p-4";
export var checkboxContainer = "_6p-6";
export var closeIcon = "_6p-i";
export var container = "_6p-0";
export var drawer = "_6p-8";
export var drawerContent = "_6p-9";
export var extraSmallText = "_6p-5";
export var fulfillmentGroupTable = "_6p-e";
export var largeText = "_6p-3";
export var loadingSpinnerContainer = "_6p-j";
export var mediumText = "_6p-2";
export var narrow = "_6p-f";
export var notificationLink = "_6p-l";
export var packageCheckIconContainer = "_6p-7";
export var slideoutHeaderActions = "_6p-g";
export var slideoutHeaderActionsShifted = "_6p-h";
export var slideoutHeaderContainer = "_6p-a";
export var slideoutModal = "_6p-c";
export var stickyHeaderWrapper = "_6p-b";
export var table = "_6p-k";
export var tableContainer = "_6p-d";
export var tertiaryText = "_6p-1";